// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import clsx from 'clsx';
import camelCase from 'lodash/camelCase';

import {MetricEntryBehavior} from 'common/query-builder/query-entry-section/types';
import {useTranslation} from 'common/i18n/hooks';
import {SvgIconReact} from 'common/components/svg-icon';

import {OverflowControls} from '../common/controls';
import styles from './index.module.styl';
import {MetricTypeIcons} from './catalog';

interface MetricBehaviorProps {
  children?: React.ReactNode;
  behavior: MetricEntryBehavior;
}

/**
 * Defines the wrapping component for a behavior definition.
 * This component is responsible for:
 * - Saving a behavior
 * - Reset changes on a changed behavior
 * - Selecting a saved behavior
 */
export function MetricBehaviorBase({behavior, children}: MetricBehaviorProps) {
  const {t} = useTranslation();

  /** @todo implement all these methods */
  const handleSaveBehavior = () => null;
  const handleRenameBehavior = () => null;
  const handleRemoveBehavior = () => null;

  /** @todo extract type from behavior */
  const type = behavior.type;

  return (
    <div className={clsx(styles.behavior, styles[camelCase(`is-${type}-metric`)])}>
      {/* metric header area */}
      <div className={styles.header}>
        {/* metric label/selector */}
        <SvgIconReact className={styles.icon} icon={MetricTypeIcons[type]} />

        {/* @todo integrate behavior selector */}
        <div className={styles.title}>{behavior.name ?? `New Definition`}</div>

        {/* metric controls */}
        <div className={styles.actions}>
          {/* metric overflow controls for saving, resetting, etc... */}
          <OverflowControls
            items={[
              {
                items: [
                  {
                    label: t(`query-builder.actions.save-behavior`),
                    icon: `save`,
                    onSelect: handleSaveBehavior,
                  },
                  /** @todo integrate reset button */
                  {
                    label: t(`query-builder.actions.rename`),
                    icon: `edit`,
                    onSelect: handleRenameBehavior,
                  },
                  {
                    label: t(`query-builder.actions.remove`),
                    icon: `x`,
                    onSelect: handleRemoveBehavior,
                  },
                ],
              },
            ]}
          />
        </div>
      </div>

      {/* behavior definition */}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
